import React from 'react'

import AdminLayout from '../components/AdminLayout'

import './inventory.css'

const Inventory = () => {
  return (
    <AdminLayout title="Inventory" activeNav="inventory" pageTitle="Inventory - Namami Gange">
      <div className="admin-card-grid">
        <div className="admin-stat-card">
          <h3>In Stock</h3>
          <div className="admin-stat-value">923</div>
          <div className="admin-stat-sub">73%</div>
        </div>
        <div className="admin-stat-card">
          <h3>Low Stock</h3>
          <div className="admin-stat-value">62</div>
          <div className="admin-stat-sub">5%</div>
        </div>
        <div className="admin-stat-card">
          <h3>Out of Stock</h3>
          <div className="admin-stat-value">28</div>
          <div className="admin-stat-sub">2%</div>
        </div>
        <div className="admin-stat-card">
          <h3>Not Ordered</h3>
          <div className="admin-stat-value">240</div>
          <div className="admin-stat-sub">19%</div>
        </div>
      </div>

      <div className="inventory-mid">
        <div className="admin-panel">
          <h2>Stock Overview</h2>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Category</th>
                  <th>Available Qty</th>
                  <th>Unit</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Alum Coagulant</td>
                  <td>Chemicals</td>
                  <td>450</td>
                  <td>kg</td>
                  <td>
                    <span className="inventory-status-in">• In Stock</span>
                  </td>
                </tr>
                <tr>
                  <td>Sludge Dewatering Polymer</td>
                  <td>Chemicals</td>
                  <td>120</td>
                  <td>kg</td>
                  <td>
                    <span className="inventory-status-in">• In Stock</span>
                  </td>
                </tr>
                <tr>
                  <td>Chlorine Tablets</td>
                  <td>Spares</td>
                  <td>25</td>
                  <td>kg</td>
                  <td>
                    <span className="inventory-status-low">• Low Stock</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="admin-panel">
          <h2>Quick Actions</h2>
          <div className="inventory-actions">
            <button type="button" className="inventory-action inventory-action--a">
              <span className="inventory-action-plus">+</span>
              Add Item
            </button>
            <button type="button" className="inventory-action inventory-action--c">
              <span className="inventory-action-plus">+</span>
              Issue Item
            </button>
            <button type="button" className="inventory-action inventory-action--b">
              <span className="inventory-action-plus">+</span>
              Create PO
            </button>
            <button type="button" className="inventory-action inventory-action--d">
              <span className="inventory-action-plus">+</span>
              Stock Report
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}

export default Inventory
